import { render, staticRenderFns } from "./bettingInfo.vue?vue&type=template&id=755412ee&scoped=true&"
import script from "./bettingInfo.vue?vue&type=script&lang=js&"
export * from "./bettingInfo.vue?vue&type=script&lang=js&"
import style0 from "./bettingInfo.vue?vue&type=style&index=0&id=755412ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755412ee",
  null
  
)

export default component.exports